import Vue from 'vue';
import Vuex from 'vuex';
import basket from './basket'
import axios from 'axios';
import subscribeProduct from './subscribeProduct'
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        basket,
        subscribeProduct
    },

    plugins: [
        createPersistedState({
            paths: ['basket.storeProducts'],
        }),
    ],
})



// WEBPACK FOOTER //
// ./src/store/index.js